.hide-strip{fill:transparent!important}
/*# sourceMappingURL=percent-strip.component-QEMTGAMG.css.map */
